import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
    const { user, ready, login } = useAuth();
    const nav = useNavigate();
    const [form, setForm] = useState({ email: "", password: "" });
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        document.title = "Admin — MIDI Pictures";
    }, []);

    useEffect(() => {
        if (ready && user) nav("/admin", { replace: true });
    }, [ready, user, nav]);

    const onSubmit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        try {
            await login(form.email, form.password);
            nav("/admin", { replace: true });
        } catch (err) {
            setError(formatApiError(err.response?.data?.detail) || "Credenciales inválidas");
        } finally {
            setBusy(false);
        }
    };

    return (
        <main data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6">
            <form onSubmit={onSubmit} className="w-full max-w-md space-y-8">
                <div>
                    <p className="text-[11px] tracking-[0.32em] uppercase text-white/45 mb-3">Admin access</p>
                    <h1 className="font-display tracking-tightest text-5xl">midi<span className="text-[color:var(--midi-accent-strong)]">.</span></h1>
                </div>

                <div>
                    <label className="text-[10px] tracking-[0.32em] uppercase text-white/40 block mb-2">Email</label>
                    <input
                        data-testid="admin-email"
                        type="email"
                        required
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        className="w-full bg-transparent border-b border-white/20 focus:border-[color:var(--midi-accent-strong)] outline-none py-2 text-lg"
                    />
                </div>
                <div>
                    <label className="text-[10px] tracking-[0.32em] uppercase text-white/40 block mb-2">Password</label>
                    <input
                        data-testid="admin-password"
                        type="password"
                        required
                        value={form.password}
                        onChange={(e) => setForm({ ...form, password: e.target.value })}
                        className="w-full bg-transparent border-b border-white/20 focus:border-[color:var(--midi-accent-strong)] outline-none py-2 text-lg"
                    />
                </div>

                {error && (
                    <p data-testid="admin-login-error" className="text-sm text-red-400">
                        {error}
                    </p>
                )}

                <button
                    data-testid="admin-login-submit"
                    type="submit"
                    disabled={busy}
                    className="w-full font-display tracking-tightest text-2xl border-b border-white/30 hover:border-[color:var(--midi-accent-strong)] pb-3 text-left disabled:opacity-50 transition-colors duration-500"
                >
                    {busy ? "Accediendo..." : "Acceder →"}
                </button>
            </form>
        </main>
    );
}
